import { TitleCasePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { SOObjectNames } from "src/app/inventory/sales-order/constants/constants";
import { Severity } from "../../constants/constants";
import { ITermsConditions } from "../models/terms-conditions";
import { OrdersService } from "../orders.service";

@Component({
    selector: "app-terms-conditions",
    templateUrl: "./terms-conditions.component.html",
    styleUrls: ["./terms-conditions.component.scss"],
})
export class TermsConditionsComponent implements OnInit {
    allITermsConditions: ITermsConditions[] = [];
    estimateTerm: ITermsConditions;
    soTerm: ITermsConditions;
    invoiceTerm: ITermsConditions;
    creditMemoTerm: ITermsConditions;

    estimateTermText: string;
    soTermText: string;
    invoiceTermText: string;
    creditMemoTermText: string;

    // pre loaded obj
    estimateObj: any;
    soObj: any;
    invoiceObj: any;
    creditMemoObj: any;

    constructor(
        public app: AppMainComponent,
        private ordersService: OrdersService,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
        private appMainService: AppMainService
    ) {}

    ngOnInit(): void {
        this.loadPreLoadedObjects();
        this.getAllITermsConditions();
    }

    loadPreLoadedObjects() {
        this.estimateObj = this.app.preLoadedObjects.find(
            (obj) => obj.name == SOObjectNames.Estimate
        );
        this.soObj = this.app.preLoadedObjects.find(
            (obj) => obj.name == SOObjectNames.SalesOrder
        );
        this.invoiceObj = this.app.preLoadedObjects.find(
            (obj) => obj.name == SOObjectNames.Invoice
        );
        this.creditMemoObj = this.app.preLoadedObjects.find(
            (obj) => obj.name == SOObjectNames.CreditMemo
        );
    }

    getAllITermsConditions(): void {
        this.appMainService.isShowSpinner("loadTerms");
        this.ordersService.getAllITermsConditions().subscribe(
            (res: ITermsConditions[]) => {
                this.allITermsConditions = res;
                this.estimateTerm = this.allITermsConditions?.filter(
                    (t) => t?.objectId == this.estimateObj?.id
                )[0];
                this.soTerm = this.allITermsConditions?.filter(
                    (t) => t?.objectId == this.soObj?.id
                )[0];
                this.invoiceTerm = this.allITermsConditions?.filter(
                    (t) => t?.objectId == this.invoiceObj?.id
                )[0];
                this.creditMemoTerm = this.allITermsConditions?.filter(
                    (t) => t?.objectId == this.creditMemoObj?.id
                )[0];
                this.setTermsText();
                this.appMainService.isHideSpinner("loadTerms");
            },
            (error) => {
                this.appMainService.isHideSpinner("loadTerms");
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            }
        );
    }

    setTermsText() {
        this.estimateTermText = this.estimateTerm?.term || "";
        this.soTermText = this.soTerm?.term || "";
        this.invoiceTermText = this.invoiceTerm?.term || "";
        this.creditMemoTermText = this.creditMemoTerm?.term || "";
    }

    saveEstimateTermsConditions() {
        if (this.estimateTerm && this.estimateTerm.id) {
            this.estimateTerm.term = this.estimateTermText;
            this.updateTermsConditions(this.estimateTerm);
        } else {
            const data = this.getReqObjForAdd(
                this.estimateObj,
                this.estimateTermText
            );
            this.saveTermsConditions(data);
        }
    }

    saveSalesOrderTermsConditions() {
        if (this.soTerm && this.soTerm.id) {
            this.soTerm.term = this.soTermText;
            this.updateTermsConditions(this.soTerm);
        } else {
            const data = this.getReqObjForAdd(this.soObj, this.soTermText);
            this.saveTermsConditions(data);
        }
    }

    saveInvoiceTermsConditions() {
        if (this.invoiceTerm && this.invoiceTerm.id) {
            this.invoiceTerm.term = this.invoiceTermText;
            this.updateTermsConditions(this.invoiceTerm);
        } else {
            const data = this.getReqObjForAdd(
                this.invoiceObj,
                this.invoiceTermText
            );
            this.saveTermsConditions(data);
        }
    }

    saveCreditMemoTermsConditions() {
        if (this.creditMemoTerm && this.creditMemoTerm.id) {
            this.creditMemoTerm.term = this.creditMemoTermText;
            this.updateTermsConditions(this.creditMemoTerm);
        } else {
            const data = this.getReqObjForAdd(
                this.creditMemoObj,
                this.creditMemoTermText
            );
            this.saveTermsConditions(data);
        }
    }

    getReqObjForAdd(obj, term) {
        const data: ITermsConditions = {
            organizationId: this.app.companyId,
            objectId: obj?.id || 0,
            objectName: obj?.name || "",
            term: term,
            statusId: 1,
            msg: null,
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
        };
        return data;
    }

    saveTermsConditions(data) {
        this.ordersService.saveTermsConditions(data).subscribe(
            (res) => {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Terms & conditions saved successfully...",
                });
                this.getAllITermsConditions();
            },
            (error) => {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            }
        );
    }

    updateTermsConditions(data) {
        data.updatedSource = this.app.userIP;
        data.updatedBy = this.app.user.userId;
        data.updatedDate = this.app._saveDateTimeWithZone(new Date());

        this.ordersService.updateTermsConditions(data).subscribe(
            (res) => {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Terms & conditions updated successfully...",
                });
                this.getAllITermsConditions();
            },
            (error) => {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            }
        );
    }
}
